import loadReduxAction from 'modules/redux/actions/load'
import getPathFromDomainPathReduxUtil from 'modules/redux/utils/get-path-from-domain-map-path'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import { WORKOUT_CLASS_NAME } from 'modules/training/models/workout/constants'
import {
  WORKOUTS_ACTION,
  WORKOUTS_DOMAIN,
  WORKOUTS_ENDPOINT,
  WORKOUTS_PATH
} from 'modules/workout/redux/constants'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import {
  logUtil,
  getObjectUtil
} from 'packages/src'

function loadBySharedKeyWorkoutAction (params = {}) {
  return async (dispatch) => {
    const shareKey = params.shareKey || getObjectUtil(params, 'match.params.shareKey')
    logUtil('loadBySharedKeyWorkoutAction').debug(`loading shared workout with shareKey ${shareKey}`)
    if (!shareKey) {
      logUtil('loadBySharedKeyWorkoutAction').warn('shareKey not provided')
      return
    }

    try {
      await dispatch(
        loadReduxAction({
          type: WORKOUTS_ACTION.LOAD_BY_SHARE_KEY,
          payload: {
            endpoint: getEndpointTrainingUtil(
              interpolateRouteUtil(
                WORKOUTS_ENDPOINT.LOAD_BY_SHARE_KEY, { shareKey }
              )
            ),
            domainListPath: WORKOUTS_PATH.ALL,
            path: getPathFromDomainPathReduxUtil(WORKOUTS_DOMAIN, shareKey),
            data: {
              shareKey,
              className: WORKOUT_CLASS_NAME
            }
          },
          options: params.options
        })
      )
    } catch (error) {
      logUtil('loadBySharedKeyWorkoutAction').error('loading workout failed ', error)
    }
  }
}

export {
  loadBySharedKeyWorkoutAction
}
